<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <BaseBreadcrumbs :crumbs="crumbs" class="px-0 py-0"/>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="8"
      >
        <v-card flat class="mb-4 product-info">
          <v-card-title class="subheading font-weight-bold justify-left">
            Thông tin sản phẩm
          </v-card-title>
          <v-card-text>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="12" md="7">
                <v-list dense>
                  <v-list-item>
                    <v-list-item-content class="font-weight-medium">Tên sản phẩm:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.tenCayTrong}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="font-weight-medium">Mùa vụ:</v-list-item-content>
                    <v-list-item-content class="align-end" v-html="formatMuaVu(item.muaVu)"/>
                  </v-list-item>
                  <v-list-item v-if="item.khuVucPhanBo">
                    <v-list-item-content class="font-weight-medium">Khu vực:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{ item.khuVucPhanBo }}
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="5"
              >
                <v-img
                  v-if="item.hinhAnhBase64"
                  contain
                  width="100%"
                  height="100%"
                  :src="item.hinhAnhBase64"
                  class="mx-auto"
                />
                <v-img
                  v-else
                  contain
                  width="100%"
                  height="100%"
                  src="@/assets/dac-san-logo.jpg"
                  class="mx-auto"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-row>
          <v-col cols="12">
            <v-card flat>
              <v-card-text>
                <v-tabs
                  color="primary"
                  class="rounded-t-lg"
                  background-color="primary"
                  dark
                  centered
                >
                  <v-tab>Mô tả sản phẩm</v-tab>
                  <v-tab>Tình hình sản xuất</v-tab>
                  <v-tab>Mã số vùng trồng</v-tab>

                  <v-tab-item class="pt-4">
                    <v-row v-if="item.moTa">
                      <v-col cols="12">
                        <div v-html="item.moTa"/>
                      </v-col>
                    </v-row>
                    <span v-else>
                      Không tìm thấy dữ liệu
                    </span>
                  </v-tab-item>
                  <v-tab-item class="pt-4">
                    <v-row v-if="item.tinhHinhSxTongQuan">
                      <v-col cols="12">
                        <div v-html="item.tinhHinhSxTongQuan"/>
                      </v-col>
                    </v-row>
                    <span v-else>
                      Không tìm thấy dữ liệu
                    </span>
                  </v-tab-item>
                  <v-tab-item class="pt-4">
                    <v-row v-if="msVungTrongs.length > 0">
                      <v-col cols="12">
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left text-subtitle-1">
                                  Mã số
                                </th>
                                <th class="text-left text-subtitle-1">
                                  Vùng trồng
                                </th>
                                <th class="text-center text-subtitle-1">
                                  Xã
                                </th>
                                <th class="text-center text-subtitle-1">
                                  Huyện
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(vtr,index) in msVungTrongs" :key="`ms${index}`">
                                <td>{{ vtr.maVung }}</td>
                                <td>{{ vtr.tenVungTrong }}</td>
                                <td class="text-center"><span v-if="vtr.dmXa">{{ vtr.dmXa.ten }}</span></td>
                                <td class="text-center"><span v-if="vtr.dmHuyen">{{ vtr.dmHuyen.ten }}</span></td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                    </v-row>
                    <span v-else>
                      {{msVungTrongLoading ? 'Đang tải dữ liệu...' : 'Không tìm thấy dữ liệu!'}}
                    </span>
                  </v-tab-item>
                </v-tabs>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-spacer/>
      <v-col
        cols="12"
        sm="12"
        md="4"
      >
        <v-card flat class="text-center"
          :loading="relatedLoading"
        >
          <v-card-text>
            <span class="text-h6 font-weight-bold">
              Các sản phẩm khác
            </span> 
          </v-card-text>
        </v-card>
        <v-card 
          v-if="relatedItems.length == 0"
          flat 
          class="text-center"
        >
          <v-card-text>
            <span>
              Chưa tìm thấy sản phẩm phù hợp
            </span>
          </v-card-text>
        </v-card>
        <v-card flat
          v-for="(related_item, index) in relatedItems"
          :key="`ri${index}`"
          :to="{ name: 'TreeProductTrace', params: { id: related_item.id }}"
          class="px-6"
        >
          <div class="d-flex flex-no-wrap">
            <v-avatar
              class="ma-3 rounded-lg"
              size="100"
              tile
            >
              <v-img 
                v-if="related_item.hinhAnhBase64"
                :src="related_item.hinhAnhBase64"
              />
              <v-img 
                v-else
                src="@/assets/dac-san-logo.jpg"
              />
            </v-avatar>
            <div>
              <v-card-title class="text-h6">
                {{related_item.tenCayTrong}}
              </v-card-title>
              <v-card-subtitle>
                Thuộc nhóm: 
                <span v-if="related_item.nhomCayCayTrong">
                  {{related_item.nhomCayCayTrong.name}}
                </span>
              </v-card-subtitle>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import moment from 'moment';
  import BaseBreadcrumbs from '@/components/base/BaseBreadcrumbs';
  import { mapActions } from 'vuex';
  import SystemSevice from '@/services/System';
  export default {
    components: { 
      BaseBreadcrumbs
    },
    data: () => ({
      crumbs: [],
      item: {},
      relatedItems: [],
      tinhHinhSanXuatCayAnQuas_show: false,
      tinhHinhSauBenhCayAnQuas_show: false,
      msVungTrongs_show: false,
      tinhHinhSauBenhCayAnQuas: [],
      tinhHinhSanXuatCayAnQuas: [],
      msVungTrongs: [],
      msVungTrongLoading: false,
      relatedLoading: false,
    }),
    watch: {
      "$route.params.id": function() {
        this.getProductDetail();
        this.getRelatedItems();
        this.scrollToTop();
      }
    },
    computed: {
      tongDienTich() {
        let tongdientich = 0;
        this.tinhHinhSanXuatCayAnQuas.forEach(function(obj, indx){
          tongdientich += parseFloat(obj.dienTich);
        })
        return tongdientich.toFixed(2);
      },
      tongSanLuong() {
        let tongsanluong = 0;
        this.tinhHinhSanXuatCayAnQuas.forEach(function(obj, indx){
          tongsanluong += parseFloat(obj.sanLuong);
        })
        return tongsanluong.toFixed(2);
      },
      khuVucPhanBo() {
        let khuVucs = [];
        this.tinhHinhSanXuatCayAnQuas.forEach(function(obj, indx){
          if(!khuVucs.includes(obj.dmHuyen.ten))
            khuVucs.push(obj.dmHuyen.ten);
        });
        return khuVucs.join(", ");
      }
    },
    mounted() {
      this.getProductDetail();
      this.getRelatedItems();
      SystemSevice.setSiteViewLocal({
        name: `TreeProductTrace@${this.$route.params.id}`,
      });
    },
    methods: {
      ...mapActions([
        'getLoader'
      ]),
      getProductDetail(){
        const app = this;
        const url = 'api/v1/public/get-tree-special-prod-detail';
        app.getLoader(true);
        axios.get(`${url}/${app.$route.params.id}`)
          .then(response => {
            app.item = response.data;
            app.getTreeProductStatus(app.item.id);
            app.getTreeProductAreaCode(app.item.id);
            app.crumbs = [
              {
                text: 'Sản phẩm đặc sản',
                disabled: false,
                href: '/products/special/tree',
              },
              {
                text: app.item.tenCayTrong,
                disabled: true
              }
            ];
            app.getLoader(false);
          })
          .catch(function (error) {
            console.log(error);
            app.getLoader(false);
          });
      },
      getTreeProductStatus(id){
        this.tinhHinhSauBenhCayAnQuas = [];
        this.tinhHinhSanXuatCayAnQuas = [];
        axios.get(`api/v1/public/get-tree-product-status/${id}`)
          .then(response => {
            this.tinhHinhSauBenhCayAnQuas = response.data.tinhHinhSauBenhCayAnQuas;
            this.tinhHinhSanXuatCayAnQuas = response.data.tinhHinhSanXuatCayAnQuas;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      getTreeProductAreaCode(id){
        const app = this;

        app.msVungTrongLoading = true;
        app.msVungTrongs = [];
        
        axios.get(`api/v1/public/get-tree-product-area-code/${id}`)
          .then(response => {
            app.msVungTrongs = response.data;
            app.msVungTrongLoading = false;
          })
          .catch(function (error) {
            console.log(error);
            app.msVungTrongLoading = false;
          });
      },
      getRelatedItems(){
        const app = this;
        app.relatedItems = [];
        app.relatedLoading = true;
        axios.get(`api/v1/public/products-related/trongtrot/${app.$route.params.id}`)
          .then(response => {
            app.relatedItems = response.data;
            app.relatedLoading = false;
          })
          .catch(function (error) {
            console.log(error);
            app.relatedLoading = false;
          });
      },
      format_date(value){
        if (value) {
          return moment(String(value)).format('DD-MM-YYYY');
        }
      },
      scrollToTop() {
        window.scrollTo(0,0);
      },
      formatMuaVu(mv) {
        if(!mv) return mv;
        let mv_array = mv.split(';');
        if(mv_array.length > 0){
          return mv_array.join('<br>');
        }
        return mv;
      }
    }
  }
</script>
<style scoped>
  .v-card--flat {
    box-shadow: 0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12) !important;
  }
  .product-info .v-list-item__content{
    font-family: Arial, Helvetica, sans-serif !important;
    font-size: 16px;
  }
</style>